import { MINUS } from './fixed';

let groupedFixedCache: Map<number, Intl.NumberFormat> | undefined;

function groupedFixed(magnitude: number, digits: number): string {
  groupedFixedCache ??= new Map();
  let formatter = groupedFixedCache.get(digits);
  if (!formatter) {
    formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    });
    groupedFixedCache.set(digits, formatter);
  }
  return formatter.format(magnitude);
}

/**
 * A signed figure with thousands separators, signed only when the figure as
 * printed is not zero: "−0.0" is a claim about a direction the number does
 * not show. `plus` marks a gain explicitly where a reader compares signs
 * down a column. Rounding is `Intl`'s.
 */
export function formatGroupedSigned(
  value: number,
  { digits = 2, plus = false }: { digits?: number; plus?: boolean } = {}
): string {
  const magnitude = Math.abs(value);
  const formatted = groupedFixed(magnitude, digits);
  const negative = value < 0;
  const nonZero = Number(formatted.replace(/,/g, '')) !== 0;
  if (negative && nonZero) return `${MINUS}${formatted}`;
  if (!negative && plus && nonZero) return `+${formatted}`;
  return formatted || String(magnitude);
}

/** A ratio such as Sharpe, signed the same way: "1.12", "−0.40". */
export function formatSignedNumber(value: number, digits = 2): string {
  return formatGroupedSigned(value, { digits });
}
